/*
 * @Desc: 
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2023-03-13 11:47:01
 */
/**
  * 充值卡 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const chargecard = {
    // 列表
    list (params) {
        return axios.get(api + 'chargecard/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'chargecard/create', qs.stringify(params))
    },
    //获取编辑信息
    orders (params) {
        return axios.get(api + 'chargecard/orders', { params: params })
    },
    //修改
    edit (params) {
        return axios.post(api + 'chargecard/edit', qs.stringify(params))
    },
    detail (params) {
        return axios.get(api + 'chargecard/detail', { params: params })
    },
    //导出充值卡
    export (params) {
        return axios.post(api + 'export/chageCard', qs.stringify(params))
    },
    //禁用充值卡
    // 修改状态
    status (params) {
        return axios.post(api + 'chargecard/status', qs.stringify(params))
    },
    //导出充值卡
    exportOrder (params) {
        return axios.post(api + 'export/cardOrder', qs.stringify(params))
    },
    // 导入
    import (params) {
        return axios.post(api + 'chargecard/import', qs.stringify(params))
    },
}


// 导出接口
export default chargecard